import { Component, OnInit, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppService } from '../app.service';
import { GlobalService } from '../global/services/global.service';
import { buildHeaderDataShell } from '../shared/workspace-element-context';
import { AppFooterService } from './app-footer.service';

@Component({
    selector: 'gtw-app-footer',
    templateUrl: './app-footer.component.html',
    styleUrls: ['./app-footer.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppFooterComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  public cookieAcceptanceContent =
    'This site uses cookies to collect information about your browsing activities in order to provide you with more relevant content and promotional materials, and help us understand your interests and enhance the site. By continuing to browse this site you agree to the use of cookies.';
  currentTaxYear = new Date().getFullYear();
  showCookieBlock = true;
  baseURLs: any = {};
  globalData: any = {};
  footerContent = '';

  constructor(
    private appFooterService: AppFooterService,
    private gtwGlobal: GlobalService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.applyFooterFromServices();
  }

  private applyFooterFromServices(): void {
    this.globalData = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    const u = this.globalData.userSettingsData?.user || this.gtwApp.USER_SETTINGS?.user || {};
    if (u.cookie_acceptance && u.cookie_acceptance == 'yes') {
      this.showCookieBlock = false;
    } else {
      this.showCookieBlock = true;
    }
    this.footerContent =
      '© ' +
      this.currentTaxYear +
      ' PwC. PwC refers to the PwC network and/or one or more of its member firms, each of which is a separate legal entity. Please see www.pwc.com/structure for further details.';
  }

  iUnderstand() {
    const gc = this.globalData.generalConfigData || {};
    const baseUrl = gc.base_url || '';
    const clientKey =
      this.gtwApp.USER_SETTINGS?.user?.client?.client_key ??
      this.gtwApp.USER_SETTINGS?.user?.client_key ??
      '';
    this.appFooterService.acceptCookieApi(baseUrl, clientKey, 'yes').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        if (data.callSuccess == 1) {
          this.showCookieBlock = false;
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        console.log('Gost Console progress bar');
      }
    );
  }
}
